import React from "react";

interface DimensionHugProps {
  className?: string;
}

const DimensionHug: React.FC<DimensionHugProps> = ({ className }) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 5.5L6.5 3L9 0.5M1 5.5L3.5 3L1 0.5"
        stroke="#1E293B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DimensionHug;
